import { useDispatch, useSelector } from 'react-redux';
/** 应用级类型安全派发 Hook，使用 React Redux 原生类型绑定避免调用方重复泛型。 */
export const useAppDispatch = useDispatch.withTypes();
/** 应用级类型安全选择 Hook，让类型感知 ESLint 能稳定识别选择结果。 */
export const useAppSelector = useSelector.withTypes();
